<script setup>
import { NButton } from "naive-ui";
import { getDevices } from "../common/index";
import { useStore } from "@/hooks/stores/global";
import { storeToRefs } from "pinia";
import { nextTick, onMounted, onUnmounted } from "vue";

const main = useStore();
const { device } = storeToRefs(main);
const connectDevice = async () => {
  // 连接设备
  await navigator.hid.requestDevice({
    filters: [
      {
        vendorId: "0x1915",
        productId: "0x072C",
      },
      {
        vendorId: "0x1915",
        productId: "0x0727",
      },

      // 有线
      {
        vendorId: "0x1915",
        productId: "0x07A1",
      },
      {
        vendorId: "0x1915",
        productId: "0x07A0",
      },
      // 无线
      {
        vendorId: "0x1915",
        productId: "0x0727",
      },
      {
        vendorId: "0x1915",
        productId: "0x0728",
      },
      // 光微动有线
      {
        vendorId: "0x1915",
        productId: "0x07A2",
      },
      // 升级模式
      {
        vendorId: "0x1915",
        productId: "0x0829",
      },
      {
        vendorId: "0x1915",
        productId: "0x0828",
      },
      // 837鼠标
      {
        vendorId: "0x1915",
        productId: "0x07A3",
      },
    ],
  });
  if (!device.value) {
    location.reload();
  }
  // 存储连接的设备
  await getDevices();
};
const handleScroll = (evt) => {
  window.scrollTo({ top: 0, behavior: "smooth" });
  window.removeEventListener("scroll", handleScroll);
};
onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});
onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<template>
  <div class="index">
    <h1>允许浏览器连接到设备</h1>
    <p>
      点击下方按钮，您的浏览器会在地址栏下方弹出一个对话框（如操作示例中所示）。在列表中点击设备名称以选择设备，然后点击“连接”。
    </p>
    <div>
      <n-button color="#8a2be2" @click="connectDevice"> 连接到设备 </n-button>
    </div>
  </div>
</template>

<style lang="less" scoped>
.index {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 2em 24px 24px;
  height: 100%;
  width: 100%;
  background-color: #fdf8fd;
}
</style>
../common/index
